// extracted by mini-css-extract-plugin
export default {"productDescription":"I_-z","featuredDescription":"J_-z","description":"K_-z","more":"L_-z","descriptionSku":"M_-z"};